import { inkFor } from '@tt/shared';
import { cn } from '@/lib/utils';

/**
 * A project's colour sample. The border is {@link inkFor} — the same hue darkened until it
 * clears 3:1 — so a pale pastel still has an edge you can see against the page.
 */
export function Swatch({ color, className }: { color: string; className?: string }) {
  return (
    <span
      className={cn('block rounded-full border', className)}
      style={{ backgroundColor: color, borderColor: inkFor(color) }}
      aria-hidden="true"
    />
  );
}
